module.exports = __webpack_public_path__ + "img/logo_h.a0248537.png";